export enum PeriodTypeForOrdersInTransport {
  LastPackageStatus = 0,
  OrderDispatched = 1,
  OrderCreated = 2,
  LastPackageStatusAndOrderCreated = 3,
  LastPackageStatusAndOrderDispatched = 4,
  OrderDispatchedAndOrderCreated = 5
}